// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ModalTokens } from './type';

const modalTokens: ModalTokens = {
  modalMaskBackground: 'rgba(2, 11, 24, 0.3)',
  modalMaskLightBackground: 'rgba(2, 11, 24, 0.01)',
  modalPanelPaddingY: 'Padding-24',
  modalPanelPaddingX: 'Padding-24',
  modalPanelBackground: 'Neutral-fill-1',
  modalPanelShadow: 'Shadow-3',
  modalPanelBorder: 'Neutral-border-1',
  modalPanelGap: 'Padding-16',
  modalPanelRadius: 'Radius-4',
  modalPanelFontSize: '14/regular',
  modalHeaderIconMarginEnd: 'Margin-8',
  modalHeaderIconMarginTop: 'Size-2',
  modalHeaderIconSize: 'Size-8',
  modalHeaderCloseMarginXStart: 'Margin-16',
  modalHeaderCloseSize: 'Size-8',
  modalHeaderCloseTop: 'Size-2',
  modalHeaderCloseColor: 'Neutral-text-4',
  modalHeaderCloseBackgroundColor: 'Neutral-fill-2',
  modalHeaderFontSize: '16/regular',
  modalDrawerTitlePaddingY: 'Padding-12',
  modalDrawerTitlePaddingX: 'Padding-16',
  modalDrawerTitleBackgroundColor: 'Neutral-fill-2',
  modalDrawerBodyPaddingY: 'Padding-16',
  modalDrawerBodyPaddingX: 'Padding-16',
  modalDrawerFooterPaddingY: 'Padding-16',
  modalDrawerFooterPaddingX: 'Padding-16',
  modalDrawerCloseBackgroundColor: 'Neutral-fill-3',
  modalFontSize: '14/regular',
};

export default modalTokens;
